import {useState} from 'react';
import {Modal, Input, Radio, Select, Button, message} from 'antd';
import styles from './Modals.module.scss';

const {TextArea} = Input;
const {Option} = Select;

export const CorrectAiModal = ({visible, onClose, originalResponse}) => {
  const [applyTo, setApplyTo] = useState('session');

  const handleSubmit = () => {
    message.success('AI correction submitted successfully.');
    onClose();
  };

  return (
    <Modal
      title="Correct AI Response"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          style={{backgroundColor: '#22c55e', borderColor: '#22c55e'}}>
          Submit Correction
        </Button>,
      ]}>
      <div className={styles.modalContent}>
        <div className={styles.readOnlyBlock}>
          <label>What Sassandra said:</label>
          <div className={styles.aiText}>{originalResponse}</div>
        </div>

        <div className={styles.inputBlock}>
          <label>What it should have said:</label>
          <TextArea rows={4} placeholder="Type the correct response..." />
        </div>

        <div className={styles.inputBlock}>
          <label>Apply correction to:</label>
          <Radio.Group
            onChange={e => setApplyTo(e.target.value)}
            value={applyTo}>
            <Radio value="session">This session only</Radio>
            <Radio value="global">Global knowledge base</Radio>
            <Radio value="skill">Specific skill file</Radio>
          </Radio.Group>
        </div>

        {applyTo === 'skill' && (
          <div className={styles.inputBlock}>
            <Select placeholder="Select a skill file" style={{width: '100%'}}>
              <Option value="deposit_inquiries">deposit_inquiries.yaml</Option>
              <Option value="kyc_verification">kyc_verification.yaml</Option>
              <Option value="withdrawal_rules">withdrawal_rules.yaml</Option>
            </Select>
          </div>
        )}
      </div>
    </Modal>
  );
};
